import { ErrorMessage } from 'formik';
import React from 'react';
import { theme } from '../../configs/styled';
import { Alert } from '../Alert';

export interface IFromErrorMessageProps {
  name: string;
  marginTop?: string;
  alertType?: 'success' | 'info' | 'warning' | 'error' | undefined;
}

const FormErrorMessage: React.FC<IFromErrorMessageProps> = ({
  name,
  marginTop,
  alertType,
}) => {
  return (
    <ErrorMessage
      render={msg => (
        <Alert style={{ marginTop }} type={alertType} message={msg} banner />
      )}
      name={name}
    />
  );
};

FormErrorMessage.defaultProps = {
  marginTop: theme.spacing.lg,
  alertType: 'error',
};

export default FormErrorMessage;
